import { FOOD_MENU } from "../constant/constants";
import ApiService from "../utils/ApiService";
import {getParsedNumber, isOnlySpecialCharacters} from "../utils/Common";



export  const buttonStylePositive = {
    fontWeight: 600,
    backgroundColor: "#2EC114",
    color: "#FFFFFF",
    borderColor: "#2EC114",
    ":hover": {
      backgroundColor: "#000000",
      color: "#2EC114",
      borderColor: "#FFFFFF",
    },
  };

export  const buttonStyleNegative = {
    fontWeight: 600,
    backgroundColor: "#FA6060",
    color: "#FFFFFF",
    borderColor: "#FA6060",
    ":hover": {
      backgroundColor: "#000000",
      color: "#FA6060",
      borderColor: "#FFFFFF",
    },
  };

export const defaultFoodOption = {
  optionId: "",
  name: "",
  weight: 1,
  price: "",
  isSelected: false,
};

export const makeSingleFoodOptionDefaultSelected = (options) => {
  if (options.length !== 1) return options;

  options[0].isSelected = true;

  return options;
};

const validateFoodPrice = (options, allOptions) => {
  console.log('-----validateFoodPrice---', {options, allOptions});
  
  if (allOptions.length > 1 && options.length === 0) {
    return "Please, select at least one variant.";
  }

  if (options.length === 1 && getParsedNumber(options[0].price) <= 0) {
    return allOptions.length > 1 ? "Food price is required and must be greater thant 0 for selected variants." : "Food Price is required and must be greater than 0.";
  }

  if (options.some((item) => getParsedNumber(item.price) <= 0)) {
    return "Please, provide price for all selected variants.";
  }

  // Begin option name validation
  // for single variant option name optional
  if (options.length === 1) {
    return "";
  }
  
  // for multiple variant option name obligatory
  if (options.some(item => item.name.trim() === '')) return "Please, provide the name of all of the selected variants."
 
  return "";
};

export const validateFoodFrom = (data) => {
  const {
    categoryId,
    name,
    options,
    allOptions,
    addOns,
    foodAdditionGroups,
    images,
    discount,
    isDiscountInPercent,
  } = data;

  
  if (!categoryId) return "Category is required";

  if (!name) return "Food name is required";

  const priceErr = validateFoodPrice(options, allOptions);

  if (priceErr) {
    return priceErr;
  }

  
  if (isDiscountInPercent && discount > 100) {
    return "The discount price should be less than 100%";
  }

  const isSingle = options.length === 1;

  if (!isDiscountInPercent && options.some((item) => getParsedNumber(discount) > getParsedNumber(item.price))) {
    return `The discount price should be less than the  ${isSingle ? 'food price' : 'smallest price of the variants'}.`;
  }

  // Prevent names made of only special characters
  if (options.some((item) => isOnlySpecialCharacters(item.name))) {
    return "Food Variants Name cannot contain only special characters.";
  }

  // Add-ons validation
  if (addOns.length > 0 && addOns.some((item) => item.name.trim() === "")) {
    return `Please provide ${addOns.length > 1 ? 'all of the add-ons name' : 'add-ons name'}`;
  }

    if (addOns.length > 0 && addOns.some((item) => getParsedNumber(item.price) <= 0)) {
    return `Please provide ${addOns.length > 1 ? 'all of the add-ons price' : 'add-ons price'}`;
  }

  /* Validation for Addition Group */
  for (const group of foodAdditionGroups.additionGroups) {
    // Name validation
    if (!group.name.trim()) {
      return "Each addition group must have a name.";
    }

    if (group.name.trim().length > 100) {
      return "Name cannot exceed 100 characters.";
    }

    // Prevent names made of only special characters
    if (isOnlySpecialCharacters(group.name)) {
      return "Group Name cannot contain only special characters.";
    }

    // Free quantity validation
    const freeQty = group.numberOfFreeItems;
    const isValidFreeQty = (value) => {
      const parsedValue = getParsedNumber(value);
      return value !== null && value !== "" && parsedValue >= 0 && parsedValue <= 10;
    };

    console.log('---', {freeQty});

    if (!isValidFreeQty(freeQty)) {
      return `Enter a valid number (0–10, no fractions) for Number of Food [Free] of ${group.name}`;
    }

    // Price validation
    const rawPrice = group.pricePerAddition;
    const isValidPrice = (value) => {
      return value !== null &&
        typeof value === 'number' &&
        !isNaN(value) &&
        value >= 1 &&
        value <= 99999;
    };
    if (!isValidPrice(parseInt(rawPrice))) {
      return `Addition group "${group.name}" must have a valid price between 1 and 99999.`;
    }

    // Group addition price should be less than the smallest price of variation.
    const getLowestDiscountedPrice = (options, discount, isPercent) => {
      const selectedOptions = options.filter(opt => opt.isSelected);

      if (selectedOptions.length === 0) return null;

      const discountedPrices = selectedOptions.map(opt => {
        const discountValue = isPercent ? (opt.price * discount) / 100 : discount;
        return opt.price - discountValue;
      });

      return Math.min(...discountedPrices);
    };
    const lowestPrice = getLowestDiscountedPrice(options, discount, isDiscountInPercent);
    if (rawPrice >= lowestPrice) {
      return `Price per addition of group "${group.name}" should be less than food price.`
    }

    // additionItems validation
    if (group.additionItems.length === 0) {
      return `Addition group "${group.name}" must have at least one item.`;
    }

  }


  
  return null;
};

export const foodEditValidateInputs = (data) => {
  const { addOns, images, discount, isDiscountInPercent, hasMultipleOptions, foodPrice, options } = data;

  // if (options.length === 0) {
  //   return "Please, select at least one variant."
  // }

  if (!hasMultipleOptions && getParsedNumber(foodPrice) < 0) {
    return "Product price can't be negative.";
  }

  if (
    !isDiscountInPercent &&
    !hasMultipleOptions &&
    !!getParsedNumber(discount) &&
    getParsedNumber(discount) > getParsedNumber(foodPrice)
  ) {
    return "Discount should be less or equal to product price.";
  }

  if (hasMultipleOptions && options.some((item) => getParsedNumber(item.price) <= 0))
    return "Food variants price cannot be 0";

  if (addOns.length > 0 && addOns.some((item) => item.name === "" || item.price === null)) {
    return "Food add-ons cannot be blank";
  }

  if (images.length < 1) return "Food image is required";

  if (isDiscountInPercent && discount >= 100) {
    return "Discount should be less than 100%";
  }

  if (hasMultipleOptions && options.some((item) => discount >= item.price)) {
    return "The discount price should be less than the food variants' price.";
  }

  return null;
};

/**
 * This method will ensure uniform params on the basis of change case
 * change type values and meaning
 * INIT when initial loading
 * RELOAD when no param change just needed reload the list with existing param ie on food status change
 * FOOD_TYPE when food type changed
 * SEARCH when search text change
 * SORT when sorting changed
 * PAGE when page changed
 *
 * @param {*} filter
 * @param {*} changedValue
 * @param {*} changeType values can be INIT, RELOAD, FOOD_TYPE, SEARCH, SORT, PAGE
 * @returns
 */
export const getSearchParams = (filter, changedValue, changeType) => {
  if (changeType === "INIT") {
    return Object.assign(filter, {
      restaurantId: changedValue,
      page: 1,
      searchText: "",
      sortBy: "NEWEST",
    });
  }

  if (changeType === "RELOAD") {
    return filter;
  }

  if (changeType === "FOOD_TYPE") {
    return Object.assign(filter, { page: 1, searchText: "" });
  }

  if (changeType === "SEARCH") {
    return Object.assign(filter, { page: 1, searchText: changedValue });
  }

  if (changeType === "SORT") {
    return Object.assign(filter, { page: 1, sortBy: changedValue });
  }

  if (changeType === "PAGE") {
    return Object.assign(filter, { page: changedValue });
  }
};

export const retrieveFoodList = async (foodType, params, token) => {
  try {
    let res = null;

    if (foodType === FOOD_MENU.COMBO) {
      res = await ApiService.GET_ADMIN_SET_MENU_FILTER(params, token);
    } else {
      res = await ApiService.FILTER_FOOD_LIST(params, token);
    }

    const { payload } = res;

    let newFoods = [],
      options,
      addOns;

    payload.foodItems.map((food) => {
      options = [];
      addOns = [];

      food.addOns.map((add) => addOns.push(add.name));
      food.options.map((ops) => options.push(`${ops.name} - ${ops.price}tk`));

      newFoods.push({
        _id: food._id,
        order_id: 1,
        name: food.name,
        category: "",
        availableQuantity: food.availableQuantity,
        description: food.details,
        price: food.options.length > 0 ? food.options[0].price : 0,
        discount: food.options.length > 0 ? food.options[0].discount : 0,
        isDiscountInPercent: food.isDiscountInPercent,
        options: food.options,
        additionGroups: food.additionGroups,
        status: food.status.toLowerCase(),
        svariants: '6"',
        saddons: "Extra Olive",
        variants: options,
        image:
          food.images.length > 0 ? food.images[0].path : process.env.REACT_APP_APP_BASE_URL + "/images/tabletap.svg",
        addons: addOns,
        includes: food.includes ?? [],

        // ✅ Newly added fields
        isVatApplicable: food.isVatApplicable,
        isDiscountApplicable: food.isDiscountApplicable,
        isSupplementaryDutyApplicable:
          food.isSupplementaryDutyApplicable,
        supplementaryDuty:
          food.isSupplementaryDutyApplicable
            ? Number(food.supplementaryDuty || 0)
            : 0,
      });
    });

    return {
      success: true,
      total: payload.pagination.total,
      records: newFoods,
    };
  } catch (error) {
    console.error("Error while fetching foods");

    return {
      success: false,
      message: "Failed to fetch data.",
      total: 0,
      records: [],
    };
  }
};

export const getCategoryDropdownList = async (restaurantId, token) => {
  try {
    const res = await ApiService.GET_CATEGORY({ restaurantId, isSetMenu: "No" }, token);

    const data = res.payload.records;

    const items = data.map((item) => ({
      value: item.id,
      label: item.name,
    }));

    return {
      success: true,
      categoryList: data,
      categoryDropdownList: items,
    };
  } catch (error) {
    return {
      success: false,
      categoryList: [],
      categoryDropdownList: [],
    };
  }
};

// export const mergeFoodVariantsWithCategory = (
//   foodvariants,
//   categoryId,
//   categoryList
// ) => {
//   const category = categoryList.find((item) => item.id === categoryId);
//   const categoryVariants = category ? category.options : [];

//   console.log('___food_variants___', foodvariants);
//   console.log('___food_variants___cat', categoryVariants);

//   const mergedVariants = categoryVariants.map((item) => {
//     let selectedFoodVariant = foodvariants.find(
//       (fv) => (fv.optionId && fv.optionId === item._id)
//     );

//     selectedFoodVariant = selectedFoodVariant || {
//       optionId: item._id,
//       name: item.name,
//       weight: item.weight,
//       price: "",
//       isNotSelected: true,
//     };

//     return {
//       optionId: selectedFoodVariant.optionId || item._id,
//       name: selectedFoodVariant.name,
//       weight: selectedFoodVariant.weight,
//       price: selectedFoodVariant.price,
//       isSelected: !selectedFoodVariant.hasOwnProperty("isNotSelected"),
//     };
//   });

//   return mergedVariants;
// };

export function mergeFoodVariantsWithCategory(foodVariants, categoryId, categoryList) {
  const filteredFoodVariants = foodVariants.map((item) => ({...item, name: item.name !== "System Default" ? item.name : ''}));
  const category = categoryList.find((item) => item.id === categoryId);
  let categoryVariants = category ? category.options : [];
  categoryVariants = categoryVariants.filter((item) => item.name !== "System Default");
  const mergedMap = new Map();

  categoryVariants.forEach((cv) => {
    if (!mergedMap.has(cv._id)) {
      mergedMap.set(cv._id, {
        optionId: cv._id,
        name: cv.name,
        weight: cv.weight,
        price: 0,
        isSelected: false,
      });
    }
  });

  filteredFoodVariants.forEach((fv) => {
    mergedMap.set(fv.optionId, {
      optionId: fv.optionId,
      name: fv.name,
      weight: fv.weight,
      price: fv.price,
      isSelected: true,
    });
  });

  return Array.from(mergedMap.values());
}
